import React, { Fragment, useEffect, useState } from 'react';
import { Row, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Card, Badge } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { API_SpaceAddons, API_MEETING_ROOMS } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RotateSpinner } from 'react-spinners-kit';
import ReactDragListView from "react-drag-listview";
import { List, Typography } from "antd";
import "antd/dist/antd.css";
import AddOnForm from './AddOnForm';
const CategoryList = [
    { value: "CateringServices", label: "Catering Services" },
    { value: "MeetingEquipment", label: "Meeting Equipment" }
];
function AddOnList({ propertyId, history, locale }) {
    const [loading, setLoading] = useState(true);
    const [addonList, setAddonList] = useState([]);
    const [spaceList, setSpaceList] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [id, setId] = useState("");
    const [color, setColor] = useState([]);
    function generateRandomColorCategory(category) {
        var arr = [
            'primary',
            'secondary',
            'info',
            'success',
            'warning',
            'danger',
            'light',
            'dark',
            'orange',
            'blue',
            'violet',
            'light-red',
            'sky-blue',
            'outline-primary',
            'outline-secondary',
            'outline-info',
            'outline-success',
            'outline-warning',
            'outline-danger',
            'outline-light',
            'outline-dark',
        ];
        return arr[category];
    }
    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${API_MEETING_ROOMS}/all/${propertyId}`,
        }).then((result) => {
            setSpaceList(result.data);
            var cate = [];
            result.data.map((item, i) => {
                cate.push({
                    label: item.id,
                    color: generateRandomColorCategory(i)
                })
            });
            setColor(cate);
        });
        AxiosAPI({
            methhod: 'get',
            url: `${API_SpaceAddons}/list?groupId=${getGroupID()}&propertyId=${propertyId}`,
        })
            .then((res) => {
                setLoading(false);
                setAddonList(res.data);
            })
            .catch((err) => console.log('err', err));
    }, []);

    const getLocalStatement = (statements) => {
        if (statements !== undefined && statements.length > 0) {
            const index = statements.findIndex((m) => m.languageCode === locale);
            if (index === -1) {
                const englishIndex = statements.findIndex(
                    (m) => m.languageCode === 'en'
                );
                if (englishIndex !== -1) {
                    return statements[englishIndex].statement;
                }
            } else {
                return statements[index].statement;
            }
        } else {
            return '';
        }
    };
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    const onDragEnd = (fromIndex, toIndex, type, index) => {
        if (toIndex < 0) return;
        if (type === "LIST-ITEM") {
            const categories = reorder(addonList, fromIndex, toIndex);
            var data = [];
            categories.map((item, i) => {
                data.push({
                    id: item.id,
                    displayOrder: i
                })
            });
            AxiosAPI({
                method: 'post',
                url: `${API_SpaceAddons}/display-order`,
                data: { data: data },
            }).then((res) => {
                return setAddonList(categories);
            }).catch((err) => {
                console.log('err', err);
            });
        } else return new Error("NOT A VALID LIST");
    };
    return (<Fragment>
        {loading ?
            <Row>
                <Colxx xxs="5" className="mb-2"></Colxx>
                <Colxx xxs="2" className="mb-2">
                    <RotateSpinner size={60} color="#4556AC" loading={loading} />
                </Colxx>
                <Colxx xxs="5" className="mb-2"></Colxx>
            </Row> :
            addonList.length > 0 &&
            <ReactDragListView
                nodeSelector=".ant-list.draggable"
                lineClassName="dragLine"
                onDragEnd={(fromIndex, toIndex) =>
                    onDragEnd(fromIndex, toIndex, "LIST-ITEM")
                }
            >
                {addonList.map((item, index) => (
                    <List key={index} className="draggable">
                        <div className="d-flex flex-row mb-3">
                            <span className="mt-3 draggable"><a href="#"><i className="simple-icon-menu"></i></a></span>
                            <Colxx xxs="12" key={index}>
                                <Card className="d-flex flex-row mb-3">
                                    <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                                        <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                                            <p className="mb-1  text-small w-15 w-sm-100">
                                                <b>{getLocalStatement(item.itemName)}</b>
                                            </p>
                                            <p className="mb-1 text-muted text-small w-15 w-sm-100">
                                                {CategoryList.filter(l => l.value === item.category).map(k => k.label)}
                                            </p>
                                            <p className="mb-1 text-muted text-small w-50 w-sm-100">
                                                {item.spaceApplicability !== undefined && item.spaceApplicability !== null &&
                                                    item.spaceApplicability.length > 0 && item.spaceApplicability.map((l) => (
                                                        <Badge className="mt-1 mr-1"
                                                            color={color.length > 0 && color.filter(i => i.label === l).map((e) => e.color)}>
                                                            {spaceList.filter(j => j.id === l).map(elem => elem.name)}
                                                        </Badge>
                                                    ))}
                                            </p>
                                            <div className="w-20 w-sm-100">
                                                <Button
                                                    color="primary"
                                                    size="sm"
                                                    onClick={() => { setIsEdit(!isEdit); setId(item.id); }}
                                                >
                                                    Edit
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </Colxx>
                        </div>
                    </List>
                ))}
            </ReactDragListView>
        }

        {isEdit &&
            <AddOnForm
                id={id}
                formLabel={"Update AddOn's"}
                visible={isEdit}
                toggle={() => setIsEdit(!isEdit)}
            ></AddOnForm>}
    </Fragment>);
};
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(AddOnList));